import { Injectable, OnDestroy } from '@angular/core';

import { LinkedAttachmentDto, VoucherMessageAttachmentsApplyCommand, VoucherMessageViewClient } from '../api';

import { CerPromptService } from '@ui/cer-ui-prompt.service';
import { CerAppFileViewerTabComponent, TabSelectedApplyData as TabSelectedApplyData, ViewCommandEvent as ViewCommandEvent } from 'src/cer-app/cer-app-file-viewer-tab/cer-app-file-viewer-tab.component';
import { Subscription } from 'rxjs';
import { VoucherDataService } from './voucher-data.service';
import { CerFormComponent } from '@form/cer-form.component';
import { UiActionTypeEnum, UiCommandEvent, UiCommandSourceEnum } from '@ui/cer-ui-types';

@Injectable(
)

export class VoucherAttachmentService implements OnDestroy {


  constructor(private voucherDataService: VoucherDataService, private messageClient: VoucherMessageViewClient, private ui: CerPromptService) {
  }

  private subscriptionManager: Subscription = new Subscription();
  private manage(s: Subscription) {
    this.subscriptionManager.add(s);
  }

  ngOnDestroy() {
    this.subscriptionManager.unsubscribe();
  }

  private fileViewerTab: CerAppFileViewerTabComponent;
  private form: CerFormComponent;

  public init(form: CerFormComponent, fileViewerTab: CerAppFileViewerTabComponent) {
    this.form = form;
    this.form.commmand.subscribe(cmd => this.onFormCommand(cmd));
    this.fileViewerTab = fileViewerTab;
  }

  private onFormCommand(cmd: UiCommandEvent) {
    if (cmd.source == UiCommandSourceEnum.DesignChange) {
      if ([UiActionTypeEnum.PanesShow, UiActionTypeEnum.Splitter].includes(cmd.actionType)) {
        this.attachmentsResize();
      }
      /*
    switch (cmd.commandId) {
      case 'attachmentsShowHide':
        //this.attachmentsShowHide();
        break;
      case 'attachmentsPageNext':
        //this.attachmentsPageNext();
        break;
      case 'attachmentsPagePrev':
        //this.attachmentsPagePrev();
        break;
      case 'attachmentsHide':
        //this.attachmentsHide();
        break;
        */
    }
  }

  private attachmentsHide() {
    this.form.panesService.close('right');
  }

  private attachmentsResize(addPx: number = 0) {
    if (this.fileViewerTab) {
      this.fileViewerTab.resize();
    }
    /*
    if (this.attachmentsIsActive) {
      var size: string = this.splitterObj.paneSettings[1].size;
      var sizeNum: number = Number(size.substring(0, size.length - 2)) + addPx;
      size = sizeNum + 'px';
      this.splitterObj.paneSettings[1].size = size;
      if (this.fileViewerTab) {
        this.fileViewerTab.resize();
      }
    }
    */
  }

  public attachmentsPageNext() {
    /*
    if (this.attachmentsIsActive && this.detailsVm && this.detailsVm.voucherMessageAttachmentDtoList) {
      if (this.attachmentSelectedIdxDefault + 1 < this.detailsVm.voucherMessageAttachmentDtoList.length) {
        this.attachmentSelectedIdxDefault++;
      }
    }
    */
  }
  public attachmentsPagePrev() {
    /*
    if (this.attachmentsIsActive && this.detailsVm && this.detailsVm.voucherMessageAttachmentDtoList) {
      if (this.attachmentSelectedIdxDefault > 0) {
        this.attachmentSelectedIdxDefault--;
      }
    }
    */
  }

  public messageAttachmentsApply(data: TabSelectedApplyData, successCallBack: any) {
    VoucherAttachmentService.messageAttachmentsApply(data, successCallBack, this.messageClient, this.ui);
  }

  public static messageAttachmentsApply(data: TabSelectedApplyData, successCallBack: any, messageClient: VoucherMessageViewClient, ui: CerPromptService) {

    var ok = false;
    if (data.fileNames && data.fileNames.length >= 1) {
      if ((data.mode == 'split-apply' && data.fileNames.length > 1) || (data.mode == 'transfer-paste')) {
        ok = true;
      }
    }
    if (!ok) {
      ui.error("Marker venligst de nødvendige vedhæftede dokumenter");
      return;
    }

    ui.operationBegin('Behandler vedhæftede dokumenter');
    var cmd: VoucherMessageAttachmentsApplyCommand = new VoucherMessageAttachmentsApplyCommand({
      fromMsgId: data.refRowIdFrom,
      toMsgId: data.refRowIdTo,
      fileNames: data.fileNames,
      splitMessageByFile: data.mode == 'split-apply',
      copyFile: data.mode == 'transfer-paste'
    });
    messageClient.attachmentsApply(cmd).subscribe({
      next: (result) => {
        if (result) {
          if (successCallBack) {
            successCallBack();
          }
          ui.operationEnd();
        }
        else {
          ui.operationEndError("Dokumentbehandling kunne ikke gennemføres");
        }
      },
      error: (error) => {
        ui.operationEndError(error);
      }
    });
  }

  // Shortcuts
  public handleKeyDownEvent(event: KeyboardEvent) {
    /*
    //console.log(event);
    if (event.code == 'Escape') {
      if (this.attachmentsIsActive) {
        this.attachmentsShowHide()
        event.preventDefault();
      }
    }
    else if (event.altKey == true && !event.ctrlKey && !event.shiftKey) {
      switch (event.code) {
        case 'KeyY':
          this.apiSyncAll();
          break;
        case 'KeyV':
          this.attachmentsShowHide();
          break;
        case 'KeyO':
          if (this.attachmentsIsActive) {
            this.fileViewerTab.openAttachInNewTab();
          }
          break;
        case 'KeyX':
          if (this.grid.selectedRowIndex) {
            let selectedRecords: object[] = this.grid.getSelectedRecords();
            if (selectedRecords.length > 0) {
              let dto: Dto = <Dto>selectedRecords[0];
              if (dto) {
                if (dto.status == VoucherMessageStatusEnum.Inbox || dto.status == VoucherMessageStatusEnum.Voucher) {
                  this.service.detailFormOpen(dto, false);
                }
              }
            }
          }
          break;
        case 'NumpadAdd':
          if (this.attachmentsIsActive) {
            this.fileViewerTab.pdfZoomIn();
            event.preventDefault();
          }
          break;
        case 'NumpadSubtract':
          if (this.attachmentsIsActive) {
            this.fileViewerTab.pdfZoomOut();
            event.preventDefault();
          }
          break;
        case 'PageUp':
          if (this.attachmentsIsActive) {
            this.attachmentsPagePrev();
            event.preventDefault();
          }
          break;
        case 'PageDown':
          if (this.attachmentsIsActive) {
            this.attachmentsPageNext();
            event.preventDefault();
          }
          break;
      }
    }
    else if (event.altKey == true && !event.ctrlKey && event.shiftKey) {
      switch (event.code) {
        case 'NumpadAdd':
          this.splitterResize(100);
          event.preventDefault();
          break;
        case 'NumpadSubtract':
          this.splitterResize(-100);
          event.preventDefault();
          break;
      }
      */
  }

  public getAttachmentSelectextIdxDefault(attachments: LinkedAttachmentDto[]): number {
    var idx: number = 0;
    var i: number = 0;
    attachments?.forEach(a => {
      if (idx == 0 && ['.pdf', '.xml'].includes(a.fileExtension.toLocaleLowerCase())) {
        idx = i
      };
      i++;
    });
    return idx;
  }

  public onFileViewerCommand(args: ViewCommandEvent) {
    if (args == 'close') {
      this.attachmentsHide();
    }
    else {
      this.voucherDataService.detailsVmRefresh();
    }
  }
}
